import useAnalytics from "hooks/useAnalytics";

import { ANALYTICS } from "./constants";

const useContextsAnalytics = () => {
  return useAnalytics({
    page: ANALYTICS.analyticsPage,
  });
};

export default useContextsAnalytics;
